import * as React from 'react'
import { connect } from 'react-redux'
import { Container } from '@amzn/dvui/dist/Container'
import { IDetailPageState } from '../../reducers'
import { ISanitizedCarousel, sanitizedCarouselsSelector, showCarouselsSelector } from '../../selectors/carousel'
import { CarouselCollection } from './carouselCollection'
import * as stUtility from '../utilityClasses.module.scss'

export interface ICarouselProps {
  showCarousels: boolean
  carousels: ISanitizedCarousel
}

const ConnectedCarousels = ({ carousels, showCarousels }: ICarouselProps) => {
  if (!showCarousels) return null

  return (
    <Container className={`${stUtility.pageSection}`}>
      {carousels.map((carousel, idx) => {
        if (carousel === null) {
          return null
        }
        return <CarouselCollection {...carousel} key={`carousel-collection-${carousel.index}-${idx}`} />
      })}
    </Container>
  )
}

const mapStateToProps = (state: IDetailPageState): ICarouselProps => ({
  showCarousels: showCarouselsSelector(state),
  carousels: sanitizedCarouselsSelector(state)
})

export const Carousels = connect(mapStateToProps)(ConnectedCarousels)
